import React, { useState, useEffect } from 'react';

const Videos = () => {
	const [videos, setVideos] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const postsPerPage = 4;

	// Fetch videos from backend
	useEffect(() => {
		fetch('http://localhost:5000/api/experienceVideos') // Replace with your actual backend URL
			.then((response) => response.json())
			.then((data) => {
				console.log('Fetched data:', data); // Debugging: Check backend response
				setVideos(Array.isArray(data.data) ? data.data : []); // Extract video array safely
			})
			.catch((error) => console.error('Error fetching videos:', error));
	}, []);

	// Pagination logic
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts =
		videos.length > 0 ? videos.slice(indexOfFirstPost, indexOfLastPost) : [];
	const npage = Math.ceil(videos.length / postsPerPage);
	const numbers = [...Array(npage).keys()].map((n) => n + 1);

	// Handle page change
	const changeCPage = (id) => {
		setCurrentPage(id);
	};

	return (
		<>
			{videos.length === 0 ? (
				<p className='text-center text-gray-500 mt-10'>No videos available.</p>
			) : (
				<div>
					{currentPosts.map((video, id) => (
						<div key={id} className='mt-10'>
							<div className='border-2 border-purple border-solid p-4 rounded-lg shadow-lg'>
								<h1 className='text-transparent font-semibold bg-clip-text bg-gradient-to-b from-purple to-gold text-xl'>
									{video.topic}
								</h1>
								<p className='text-gray-500 text-base'>
									{new Date(video.createdAt).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'long',
										day: 'numeric',
									})}
								</p>
								{video.storyVideo ? (
									<video
										src={video.storyVideo}
										controls
										controlsList='nodownload'
										className='mx-auto w-full rounded-lg mt-4'
									/>
								) : (
									<p className='text-red-500 text-center'>Video unavailable</p>
								)}
								<div className='flex justify-center gap-x-2 mt-4'>
									<button className='py-2 px-4 bg-black text-white rounded flex items-center gap-x-2'>
										<img src='/assets/images/thumb.png' alt='Like' width={20} />
										Like
									</button>
									<button className='py-2 px-4 bg-black text-white rounded flex items-center gap-x-2'>
										<img
											src='/assets/images/message.png'
											alt='Comment'
											width={20}
										/>
										Comment
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			)}

			{/* Pagination Section */}
			{npage > 1 && (
				<div className='flex justify-center mt-6 gap-2'>
					{numbers.map((n, i) => (
						<button
							key={i}
							onClick={() => changeCPage(n)}
							className={`px-4 py-2 border-2 border-black rounded ${
								currentPage === n
									? 'bg-black text-white'
									: 'bg-white text-black'
							}`}
						>
							{n}
						</button>
					))}
				</div>
			)}
		</>
	);
};

export default Videos;
